export default __webpack_public_path__ + "static/media/medical-icon.0467328e.svg";